realmCommerceApp.controller("MessagesModalController", MessagesModalController);

/*@ngInject*/
function MessagesModalController($uibModalInstance, messageHtml, messageSubject) {
    let vm = this;
    vm.onCancel = onCancel;
    vm.onAccept = onAccept;

    activate();

    function activate() {
        vm.messageHtml = messageHtml;
        vm.messageSubject = messageSubject;
    }


    function onAccept() {
        $uibModalInstance.close(true);
    }

    function onCancel() {
        $uibModalInstance.dismiss(false);
    }
}





// WEBPACK FOOTER //
// ./static/js/app/messages/messages.modal.controller.js